import api from "./api";

export const BF = {
  get: async key => {
    let dics = await api.open.dictionary.get(null, { dtyCodes: key });
    return dics && dics.obj;
  }
};
